import React from 'react'
import { MDBTable, MDBBtn, MDBCard, MDBCardBody, MDBCol,  MDBRow, MDBFooter } from 'mdbreact';

import { Redirect } from 'react-router-dom';
import axios from '../../authAxios';
import payment_unresolved from '../../Assets/payment_unresolved.svg';

// const brand_color = localStorage.getItem('brand_color')
export class PaymentUnresolved extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            brand_color: "",
            origin: '',
            nationality: '',
            travelling_to: '',
            total_applicants: '',
            total_days: '',
            visa_type: '',
            visa_category: '',
            base_currency_symbol: '',
            total_payment: '',
            dataObj: [],
            isTrackClicked: false,
            application_reference_code:''

        }
    }
    componentDidMount() {
        this.setState({brand_color : localStorage.getItem("brand_color")})
        this.api_getApplicationDetails()
        this.updatePaymentStatus(localStorage.getItem('user_id'),localStorage.getItem('application_id'));
    }

    updatePaymentStatus(userId,applicationId) {
        axios.post("/visa-payment/updatePaymentProcessingStatus",{
            "user_id": userId,
            "applicationId": applicationId,
            "payment_gateway":"",
            "txStatus": "FLAGGED",
            "transactionObj": {
                "paymentMode": "",
                "orderId": "",
                "txTime": "",
                "referenceId": "",
                "type": "",
                "txMsg": "msg",
                "signature": "",
                "orderAmount": ""
            }
        },{
            'Content-Type' : 'application/json'
        })
        .then((resp) => {
            // console.log(resp.data.dataobj);
        }).catch((err)=>{
            console.log(err);
        })
    }

    handleContinueBtnClick = e => {

    }
    handleTrackBtnClick = e => {
        this.setState({ isTrackClicked: true })
    }
    api_getApplicationDetails() {
        axios
            .post('/visa/getApplicationDetails', {
                "application_id": localStorage.getItem("application_id"),
                "user_id": localStorage.getItem('user_id'),
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((res) => {
                // console.log(res)
                if (res.data.data === "error") {


                } else {
                    this.setState({
                        dataObj: res.data.dataobj,
                        origin: res.data.dataobj.origin,
                        total_applicants: res.data.dataobj.total_applicants,
                        nationality: res.data.dataobj.nationality,
                        travelling_to: res.data.dataobj.travelling_to_country,
                        total_days: res.data.dataobj.total_days + " Days",
                        visa_type: res.data.dataobj.visa_processing_type + " | " + res.data.dataobj.visa_entry_type + " Entry" ,
                        visa_category: res.data.dataobj.payment_summary.visa_header,
                        base_currency_symbol: res.data.dataobj.payment_summary.currency,
                        total_payment: res.data.dataobj.payment_summary.total_payment,
                        application_reference_code:res.data.dataobj.application_reference_code,
                    })
                }

            })
            .catch((err) => {
                console.log(err)
            })
    }
    render() {
        if (this.state.isTrackClicked){
            return  <Redirect to="/track-application" /> 
        }
        return (
            <div>
                <h4><b>Payment Unresolved</b></h4>
                <div className="mt-4" style={{ padding: '3%', width: '100%', height: '100%', textAlign: 'center' }}>
                    <MDBCard style={{ width: '100%', height: '100%' }}>
                        <MDBCardBody>
                            <MDBCol >
                                <img style={{ marginTop: '1%', width: '80px', height: '80px' }} src={payment_unresolved} />
                                <div style={{ padding: '1%' }}>
                                    <b>Payment Unresolved</b>
                                    <br />Your payment has being authorized
                                <br />However the transaction could not be completed
                                <br />Our back office will revert back to you on email within 6 business hour
                                 </div>
                            </MDBCol>
                            <MDBRow   >
                                <MDBCol></MDBCol>

                                <MDBCol size="12" sm="6" md="6" lg="6">

                                    <MDBTable borderless style={{ textAlign: 'center', borderTop: '1px solid gray', borderRight: '1px solid gray', borderBottom: '1px solid gray', borderLeft: '1px solid gray' }}>
                                        <tr style={{ borderBottom: '1px solid gray' }}>
                                            <th style={{ textAlign: 'left' }}><b>Application Details</b></th>
                                            <td style={{ textAlign: 'left' }}></td>
                                        </tr>
                                        <tr>
                                            <th style={{ color: 'grey', textAlign: 'left' }}>Application ID</th>
                                            <td style={{ color: 'black', textAlign: 'left' }}>{this.state.application_reference_code}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ color: 'grey', textAlign: 'left' }}>Applicants</th>
                                            <td style={{ color: 'black', textAlign: 'left' }}>{this.state.total_applicants}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ color: 'grey', textAlign: 'left' }}>Country of residence(COR)</th>
                                            <td style={{ color: 'black', textAlign: 'left' }}>{this.state.origin}</td>
                                        </tr>

                                        <tr>
                                            <th style={{ color: 'grey', textAlign: 'left' }}>Nationality</th>
                                            <td style={{ color: 'black', textAlign: 'left' }}>{this.state.nationality}</td>

                                        </tr>
                                        <tr>
                                            <th style={{ color: 'grey', textAlign: 'left' }}>Travelling to</th>
                                            <td style={{ color: 'black', textAlign: 'left' }}>{this.state.travelling_to}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ color: 'grey', textAlign: 'left' }}>Visa type</th>
                                            <td style={{ color: 'black', textAlign: 'left' }}>{this.state.visa_type}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ color: 'grey', textAlign: 'left' }}>Visa Duration</th>
                                            <td style={{ color: 'black', textAlign: 'left' }}>{this.state.total_days}</td>
                                        </tr>
                                        <tr>
                                            <th style={{ color: 'grey', textAlign: 'left' }}>Total charges</th>
                                            <td style={{ color: 'black', textAlign: 'left' }}>{this.state.base_currency_symbol} {this.state.total_payment}</td>

                                        </tr>
                                    </MDBTable>
                                </MDBCol>

                                <MDBCol></MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol />
                                <MDBCol size="12" sm="6" md="6" lg="4">
                                    <MDBBtn id="continueBtn" style={{ color: 'white', backgroundColor: this.state.brand_color, width: '40%', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }}
                                        color="none" onClick={this.handleTrackBtnClick}>Track Application</MDBBtn>
                                </MDBCol>
                                <MDBCol />
                            </MDBRow>

                        </MDBCardBody>
                    </MDBCard>
                </div>
                <MDBRow>
                <MDBFooter style={{background: "#fff" ,  position: "fixed", bottom: "0px" ,width: "100%" , zIndex : "1" ,   left: "0" , right: "0" , borderTop: "1px solid #ccc" , boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)"}} color="white" className="pb-1 pt-1 text-right">

                        <MDBRow>
                            <MDBCol size="12" sm="6" md="6" lg="8" />
                            <MDBCol size="12" sm="6" md="6" lg="4">
                                {/* <MDBBtn id="continueBtn" style={{ color: 'white', backgroundColor: '#673784', width: '40%', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={this.handleContinueBtnClick}>Continue</MDBBtn> */}
                            </MDBCol>
                        </MDBRow>
                    </MDBFooter>
                </MDBRow>
            </div>
        )
    }
}

export default PaymentUnresolved;
